import type transform from '../to/linked-events-sets';

export default (linkedEventsSets: ReturnType<typeof transform>) => {
  if (linkedEventsSets.length != new Set(linkedEventsSets.map(x => x.id)).size)
    throw new Error('(Core::From::V2::LinkedEventsSet) linkedEventsSet array have two or more linkedEventsSet with the same ID');

  return linkedEventsSets
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::LinkedEventsSet) linkedEventsSet id is undefined');

      return { ...x };
    });
};
